import React from 'react';
import { MessageCircle } from 'lucide-react';
import { siteConfig } from '../mock';

const FloatingWhatsApp = () => {
  const whatsappLink = `https://wa.me/${siteConfig.whatsapp}?text=${encodeURIComponent('Quero fechar a CompreCliente.')}`;

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-8 right-8 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-2xl hover:scale-110 transition-all duration-300 animate-pulse"
      aria-label="Contact us on WhatsApp"
      style={{
        animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
      }}
    >
      <MessageCircle size={28} />
    </a>
  );
};

export default FloatingWhatsApp;
